<template>
  <Lottie id="map-belgium" class="animation" :options="mapAnimationOptions" />
</template>

<script>
import Lottie from 'chimera/all/components/Lottie'
import { getWithText } from 'chimera/all/assets/lottie/maps/belgium.js'

export default {
  name: 'MapBelgium',

  components: {
    Lottie,
  },

  props: {
    text: {
      type: String,
      default: 'heeft een specialist nodig',
    },
  },

  computed: {
    /**
     *
     * @returns {{animationData: *}}
     */
    mapAnimationOptions() {
      return {
        animationData: getWithText(this.text),
      }
    },
  },
}
</script>
